import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import {
  MatTable,
  MatTableDataSource,
  MatTableModule,
} from '@angular/material/table';
import { Subject } from 'rxjs';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBar } from '@angular/material/snack-bar';
import { WarehouseJson } from 'src/app/main/pages/services/microservices/json/warehouse.json';
import { WarehouseService } from 'src/app/main/pages/services/warehouse.service';

import { WarehouseDialogComponent } from '../../dialogs/warehouse-dialog/warehouse-dialog.component';

@Component({
  selector: 'app-warehouse',
  templateUrl: './warehouse.component.html',
  styleUrls: ['./warehouse.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    FlexLayoutModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,

    MatSlideToggleModule,
  ],
})
export class WarehouseComponent implements OnInit, OnDestroy {
  readonly dialog = inject(MatDialog);
  private fb = inject(FormBuilder);
  private service = inject(WarehouseService);
  private _unsubscribeAll!: Subject<any>;
  private _snackBar = inject(MatSnackBar);

  public dataSource?: MatTableDataSource<WarehouseJson>;
  @Input() businessUnitId = 0;
  @Output() isActiveBtn = new EventEmitter<boolean>();
  @ViewChild(MatTable, { static: true }) table?: MatTable<WarehouseJson>;
  notification: any = {};
  displayedColumns: string[] = [
    'action',
    'number',
    'type',
    'name',
    'user',
    'creationDate',
    'active',
  ];
  ngOnInit(): void {
    this._unsubscribeAll = new Subject<any>();
  }

  loadWareHouse(): void {
    this.service
      .getAllSummaryWarehouse(this.businessUnitId)
      .subscribe(warehouses => {
        if (warehouses) {
          const newWarehouse: WarehouseJson[] = warehouses.map(warehouse => ({
            ...warehouse,
            compoundNumber: this.getCompoundNumber(
              warehouse.number ?? 0,
              warehouse.type?.shortName?.toString() ?? '',
            ),
          }));
          this.dataSource = new MatTableDataSource(newWarehouse);
          if (this.dataSource?.data.length > 0) {
            this.isActiveBtn.emit(true);
          } else {
            this.isActiveBtn.emit(false);
          }
        } else {
          this.isActiveBtn.emit(false);
        }
      });
  }

  editWareHouse(warehouseId: number): void {
    const dialogRef = this.dialog.open(WarehouseDialogComponent, {
      height: '400px',
      width: '335px',
      autoFocus: false,
      data: {
        warehouseId,
        businessUnitId: this.businessUnitId,
      },
    });

    dialogRef.afterClosed().subscribe(() => this.loadWareHouse());
  }

  deleteWarehose(id: number): void {
    this.service.delete(id).subscribe(isDeleted => {
      if (isDeleted) {
        this.dataSource!.data = this.dataSource!.data.filter(
          wareHou => wareHou.id !== id.toString(),
        );
      } else {
        this.openSnack('Sucedió algo al intentar eliminar la bodega');
      }
    });
  }

  switchActive(id: number, index: number, checked: boolean): void {
    const form = this.fb.group({
      id,
      active: checked,
    });
    this.service.update(form).subscribe(data => {
      const active = data ? checked : !checked;
      this.dataSource!.data![index].active = active;
    });
  }

  private getCompoundNumber(number: number, shortNameType: string): string {
    const strNumber = number < 10 ? `0${number}` : number;
    return `${shortNameType}-${strNumber}`;
  }

  private openSnack(message: string): void {
    this._snackBar.open(message, '', {
      verticalPosition: 'top',
      horizontalPosition: 'right',
      panelClass: ['snack-error'],
      duration: 5000,
    });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(void 0);
    this._unsubscribeAll.complete();
  }
}
